import { useWorksheetUpgradeValidationLazyQuery } from '../generated/graphql-types';
export const useUpgradeValidationLazyQuery = (applyChanges) => {
    const [upgradeValidation, { data, error, loading },] = useWorksheetUpgradeValidationLazyQuery({
        fetchPolicy: 'network-only',
        variables: { applyChanges },
    });
    return {
        error,
        loading,
        data: data?.Worksheet__bulkUpgraderValidation,
        upgradeValidation,
    };
};
//# sourceMappingURL=data-model-service.js.map